import React from 'react';
import { SmallBodySemiBold } from '@ubeya/shared-web/components';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';
import { PAYROLL_CUSTOM_FIELD_TYPE } from 'shared/constants/payroll';
import { PAYROLL_FIELDS_WITHOUT_CURRENCY } from 'payroll/constants';

const PayrollFieldTotalAggregateRenderer = ({
  rowData: { summarized, subRows, fieldsTotal },
  columnData: { fieldId, type }
}) => {
  const formattingMap = useFormattingMap();

  if (subRows || summarized) {
    const newFieldValue = fieldsTotal?.[fieldId];
    if (
      type &&
      [PAYROLL_CUSTOM_FIELD_TYPE.HOURLY_WAGE_PERCENTAGE, PAYROLL_CUSTOM_FIELD_TYPE.HOURS_RELATED].includes(type)
    ) {
      return <></>;
    }

    return (
      <SmallBodySemiBold>
        {PAYROLL_FIELDS_WITHOUT_CURRENCY.includes(fieldId) ? newFieldValue : formattingMap.currency(newFieldValue)}
      </SmallBodySemiBold>
    );
  }
  return <></>;
};

export default PayrollFieldTotalAggregateRenderer;
